import { AfterContentInit, Component } from '@angular/core';

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.css']
})
export class FooterMenuComponent implements AfterContentInit {

  currentYear = '';

  ngAfterContentInit() {
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear().toString();
  }

}
